export enum GradesTypes {
  Report = 1,
  RoutineTest = 2,
  OtherTest = 3,
}

export function getGradesTypeName(value: GradesTypes): string {
  switch (value) {
    case GradesTypes.Report: return '内申点';
    case GradesTypes.RoutineTest: return '定期テスト';
    case GradesTypes.OtherTest: return 'その他テスト';
  }
}
